export enum eSearchOrdersOrderBy {
  createdAtASC = 'createdAt.asc',
  createdAtDESC = 'createdAt.desc',
  closingDateASC = 'closesOn.asc',
  closingDateDESC = 'closesOn.desc',
  stateASC = 'state.asc',
  stateDESC = 'state.desc',
  transactionCategoryASC = 'transactionCategory.asc',
  transactionCategoryDESC = 'transactionCategory.desc',
  lenderNameASC = 'lenderCompany.name.asc',
  lenderNameDESC = 'lenderCompany.name.desc',
  clientNameASC = 'clientCompany.name.asc',
  clientNameDESC = 'clientCompany.name.desc',
  statusASC = 'orderPhase.asc',
  statusDESC = 'orderPhase.desc',
  externalStatusASC = 'externalStatus.asc',
  externalStatusDESC = 'externalStatus.desc',
}

export const getSearchOrdersOrderBy = (field: string, order: 'desc' | 'asc'): eSearchOrdersOrderBy | null => {
  switch (field) {
    case 'clientCompany.name':
      return order === 'asc' ? eSearchOrdersOrderBy.clientNameASC : eSearchOrdersOrderBy.clientNameDESC;
    case 'lenderCompany.name':
      return order === 'asc' ? eSearchOrdersOrderBy.lenderNameASC : eSearchOrdersOrderBy.lenderNameDESC;
    case 'createdAt':
      return order === 'asc' ? eSearchOrdersOrderBy.createdAtASC : eSearchOrdersOrderBy.createdAtDESC;
    case 'state':
      return order === 'asc' ? eSearchOrdersOrderBy.stateASC : eSearchOrdersOrderBy.stateDESC;
    case 'orderPhase':
      return order === 'asc' ? eSearchOrdersOrderBy.statusASC : eSearchOrdersOrderBy.statusDESC;
    case 'externalStatus':
      return order === 'asc' ? eSearchOrdersOrderBy.externalStatusASC : eSearchOrdersOrderBy.externalStatusDESC;
    case 'transactionCategory':
      return order === 'asc'
        ? eSearchOrdersOrderBy.transactionCategoryASC
        : eSearchOrdersOrderBy.transactionCategoryDESC;
    case 'closesOn':
      return order === 'asc' ? eSearchOrdersOrderBy.closingDateASC : eSearchOrdersOrderBy.closingDateDESC;
    default:
      return null;
  }
};

export const getOrderByFromSearchOrders = (
  order: eSearchOrdersOrderBy
): { dataField: string; order: 'desc' | 'asc' } => {
  switch (order) {
    case eSearchOrdersOrderBy.clientNameDESC:
      return { dataField: 'clientCompany.name', order: 'desc' };
    case eSearchOrdersOrderBy.clientNameASC:
      return { dataField: 'clientCompany.name', order: 'asc' };
    case eSearchOrdersOrderBy.lenderNameDESC:
      return { dataField: 'lenderCompany.name', order: 'desc' };
    case eSearchOrdersOrderBy.lenderNameASC:
      return { dataField: 'lenderCompany.name', order: 'asc' };
    case eSearchOrdersOrderBy.createdAtDESC:
      return { dataField: 'createdAt', order: 'desc' };
    case eSearchOrdersOrderBy.createdAtASC:
      return { dataField: 'createdAt', order: 'asc' };
    case eSearchOrdersOrderBy.stateDESC:
      return { dataField: 'state', order: 'desc' };
    case eSearchOrdersOrderBy.stateASC:
      return { dataField: 'state', order: 'asc' };
    case eSearchOrdersOrderBy.statusDESC:
      return { dataField: 'orderPhase', order: 'desc' };
    case eSearchOrdersOrderBy.statusASC:
      return { dataField: 'orderPhase', order: 'asc' };
    case eSearchOrdersOrderBy.transactionCategoryDESC:
      return { dataField: 'transactionCategory', order: 'desc' };
    case eSearchOrdersOrderBy.transactionCategoryASC:
      return { dataField: 'transactionCategory', order: 'asc' };
    case eSearchOrdersOrderBy.closingDateDESC:
      return { dataField: 'closesOn', order: 'desc' };
    case eSearchOrdersOrderBy.closingDateASC:
      return { dataField: 'closesOn', order: 'asc' };
    case eSearchOrdersOrderBy.externalStatusASC:
      return { dataField: 'externalStatus', order: 'asc' };
    case eSearchOrdersOrderBy.externalStatusDESC:
      return { dataField: 'externalStatus', order: 'desc' };
  }
};
